import { RoleType } from '@elight/client/shared/utility/auth';

export class RoleHelper {
    static legacyRoles = [
        'admin',
        'sales',
        'superuser',
        'auditor',
        'no-access',
    ];

    static roles = [
        RoleType.ADMIN,
        RoleType.SUPER_USER,
        RoleType.SALES_MANAGER,
        RoleType.SALES_USER,
        RoleType.TECH_MANAGER,
        RoleType.TECH_USER,
        RoleType.TECH_SALES_USER,
        RoleType.TECH_SALES_USER_LIGHT,
        RoleType.VIEW_ONLY_USER,
        RoleType.NO_ACCESS,
        RoleType.AUDITOR,
    ];

    static userManagementRoles() {
        return [RoleType.ADMIN];
    }

    static viewProjectDataRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.SALES_MANAGER,
            RoleType.SALES_USER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
            RoleType.TECH_SALES_USER,
            RoleType.TECH_SALES_USER_LIGHT,
            RoleType.VIEW_ONLY_USER,
        ];
    }

    static editProjectDataRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.SALES_MANAGER,
            RoleType.SALES_USER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
            RoleType.TECH_SALES_USER,
            RoleType.TECH_SALES_USER_LIGHT,
        ];
    }

    static createProjectRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.SALES_MANAGER,
            RoleType.SALES_USER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
            RoleType.TECH_SALES_USER,
            RoleType.TECH_SALES_USER_LIGHT,
        ];
    }

    static deleteProjectRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.TECH_USER,
            RoleType.TECH_MANAGER,
        ];
    }

    static createAuditRequests() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.SALES_MANAGER,
            RoleType.SALES_USER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
            RoleType.TECH_SALES_USER,
            RoleType.TECH_SALES_USER_LIGHT,
        ];
    }

    static viewVariablesRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
        ];
    }

    static editVariablesRoles() {
        return [RoleType.ADMIN, RoleType.SUPER_USER, RoleType.TECH_MANAGER];
    }

    static viewDatabaseRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
        ];
    }

    static editDatabaseRoles() {
        return [RoleType.ADMIN, RoleType.SUPER_USER];
    }

    static syncDatabaseToDivisionRoles() {
        return [RoleType.ADMIN, RoleType.SUPER_USER];
    }

    static uploadDocumentsRoles() {
        return [RoleType.ADMIN, RoleType.SUPER_USER, RoleType.TECH_MANAGER];
    }

    static prepareDocumentsRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.SALES_MANAGER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
            RoleType.TECH_SALES_USER,
            RoleType.TECH_SALES_USER_LIGHT,
        ];
    }

    static viewImagesRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.SALES_MANAGER,
            RoleType.SALES_USER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
            RoleType.TECH_SALES_USER,
            RoleType.TECH_SALES_USER_LIGHT,
            RoleType.VIEW_ONLY_USER,
        ];
    }

    static editImagesRoles() {
        return [
            RoleType.ADMIN,
            RoleType.SUPER_USER,
            RoleType.TECH_MANAGER,
            RoleType.TECH_USER,
            RoleType.TECH_SALES_USER,
            RoleType.TECH_SALES_USER_LIGHT,
        ];
    }
}
